// extracted by mini-css-extract-plugin
export var content = "styles-module__content___u3Ojr";
export var info = "styles-module__info___jMR_5";
export var thin = "styles-module__thin___SHeMO";
export var largerMargins = "styles-module__largerMargins___qa_Rm";
export var marginTop = "styles-module__marginTop___FM6lP";
export var descriptive = "styles-module__descriptive___ot32_";
export var description = "styles-module__description___sVcdp";
export var lines3 = "styles-module__lines3___pXE6K";
export var inlineBlock = "styles-module__inlineBlock___uyWzl";
export var trailLink = "styles-module__trailLink___TDluv";
export var link = "styles-module__link___yhpft";
export var activityTag = "styles-module__activityTag___sHw4x";
export var nameTrailDetails = "styles-module__nameTrailDetails___rTHi3";
export var name = "styles-module__name___u0S_n";
export var trackNameDistance = "styles-module__trackNameDistance___TQFqC";
export var starsDateTrailDetails = "styles-module__starsDateTrailDetails___rsRNB";
export var dateTrailDetails = "styles-module__dateTrailDetails___bTYrX";
export var infoTrailDetails = "styles-module__infoTrailDetails___rd4UC";
export var metadataContent = "styles-module__metadataContent___X4Enc";
export var tagGroupContainer = "styles-module__tagGroupContainer____LoXu";